module.exports = __webpack_public_path__ + "static/img/1.125296b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/dingtalk/1.png
// module id = b/1+
// module chunks = 1